<form #formElement method="post" enctype="multipart/form-data" target="_blank">
  <input type="hidden" name="version" #version>
  <input type="hidden" name="result" #result>
  <button
    (mouseenter)="toggleTooltip()"
    class="btn btn-primary py-1 px-2 rounded text-uppercase bg-light-blue"
    [appDisableMultipleClickWithNoneEvent]="2000"
    (click)="buttonClicked()"
    [disabled]="selectedItemsCount | disableCopy">
    <i #loading class="icon18 se-icon-segment_retail mb-1 iconSize pl-1" role="status" aria-hidden="true"></i>
    <span class="font-weight-bolder font-size-xs d-inline-block pt-1 align-text-top" [ngClass]="selectedItemsCount > 0 ? 'pt-1' : 'py-1'">
      <ng-container i18n="@@app.shopping_cart">Shopping Cart</ng-container>
      @if (selectedItemsCount > 0) {
        <span
          [appUITooltip]="true"
          [hideTooltipAfterMs]="1500"
          ttitle="positions"
          i18n-ttitle="@@app.positions"
          [dynamicTitleParameter]="numberOfPositions"
          trigger="click"
          placement="top"
        class="badge bg-light-blue border-solid border-width-2 border-white">{{selectedItemsCount}}</span>
      }
    </span>
  </button>
</form>
